import "@fontsource/ibm-plex-mono/400.css";
import "@fontsource/ibm-plex-mono/500.css";
import "@fontsource/ibm-plex-mono/600.css";
import { playBoot } from "./boot";
import { attachShell, renderMotd } from "./shell";
import { startSonar } from "./sonar";
import { initTheme } from "./theme";
import "./styles.css";

const started = Date.now();
initTheme();
const bootEl = $("#boot");
const bootLog = $("#boot-log");
const tty = $("#tty");
const clock = $("#clock");
const motd = $("#motd");
const form = $("#prompt") as HTMLFormElement;
const input = $("#cmd") as HTMLInputElement;
const out = $("#out");
const scroll = $("#scroll");
const sonar = $("#sonar") as HTMLCanvasElement;

startSonar(sonar);
startClock(clock);
renderMotd(motd, started);
attachShell(form, input, out, scroll);
tty.addEventListener("pointerdown", () => input.focus());

const ac = new AbortController();
bootEl.hidden = false;

const skip = () => ac.abort();
window.addEventListener("keydown", skip, { once: true });
window.addEventListener("pointerdown", skip, { once: true });

playBoot(bootLog, ac.signal)
  .catch(() => undefined)
  .finally(() => {
    bootEl.hidden = true;
    tty.hidden = false;
    tty.classList.add("on");
    input.focus();
  });

function startClock(el: HTMLElement): void {
  const tick = () => {
    const d = new Date();
    el.textContent = d.toISOString().slice(11, 19) + " UTC";
  };
  tick();
  window.setInterval(tick, 250);
}

function $(sel: string): HTMLElement {
  const n = document.querySelector(sel);
  if (!(n instanceof HTMLElement)) throw new Error(`missing ${sel}`);
  return n;
}
